var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVentaRenta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "50px",
    viewBox: "0 0 85 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0250675676 0 11.0656081 15.4376056 11.0656081 15.4376056 0.0250675676 0 0.0250675676"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2",
    transform: "translate(-720.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(720.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#00B69F",
    points: "0 49.8574324 85 49.8574324 85 14.6087838 0 14.6087838"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#00D7C1",
    points: "0 48.2344595 85 48.2344595 85 12.9831081 0 12.9831081"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#00B69F",
    points: "0 46.6135135 85 46.6135135 85 11.3635135 0 11.3635135"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#00D7C1",
    points: "0 44.9905405 85 44.9905405 85 9.74054054 0 9.74054054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#00B69F",
    points: "0 43.3695946 85 43.3695946 85 8.11486486 0 8.11486486"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#00D7C1",
    points: "0 41.7486486 85 41.7486486 85 6.49594595 0 6.49594595"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#00B69F",
    points: "0 40.1168919 85 40.1168919 85 4.87094595 0 4.87094595"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#00D7C1",
    points: "0 38.4952703 85 38.4952703 85 3.24391892 0 3.24391892"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#00B69F",
    points: "0 36.8756757 85 36.8756757 85 1.62297297 0 1.62297297"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#00D7C1",
    points: "0 -0.000135135135 0 24.2066216 15.4378889 35.2471622 85 35.2471622 85 -0.000135135135"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, 1.208784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3517944,21.9739865 L43.3517944,23.4003378 L41.9804611,23.4003378 L41.9804611,21.9739865 C39.7090722,21.8699324 37.9779056,21.1929054 36.8540167,20.2847973 L37.9779056,19.2449324 C38.8307389,19.9726351 40.2039611,20.6172297 41.9804611,20.7638514 L41.9804611,16.8523649 C39.6911278,16.4010135 37.3271833,15.8503378 37.3271833,13.8712838 C37.3271833,12.2084459 39.2840722,11.035473 41.9804611,10.8956081 L41.9804611,9.43074324 L43.3517944,9.43074324 L43.3517944,10.9118243 C45.22085,11.0206081 46.7102389,11.5739865 47.8105167,12.3888514 L46.6856833,13.3726351 C45.7856278,12.6638514 44.6182944,12.2611486 43.3517944,12.1293919 L43.3517944,15.6449324 C45.6789056,16.1064189 48.1476833,16.7266892 48.1476833,18.8239865 C48.1476833,20.2847973 46.8396278,21.7888514 43.3517944,21.9739865 M42.4999056,5.28682432 C35.1370167,5.28682432 29.1652944,10.2658784 29.1652944,16.4152027 C29.1652944,22.5618243 35.1370167,27.5456081 42.4999056,27.5456081 C49.8646833,27.5456081 55.8364056,22.5618243 55.8364056,16.4152027 C55.8364056,10.2658784 49.8646833,5.28682432 42.4999056,5.28682432",
    id: "Fill-11",
    fill: "#00B69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3517944,17.1043919 L43.3517944,20.7847973 C45.4900167,20.6172297 46.2134611,19.7057432 46.2134611,18.9307432 C46.2134611,17.8766892 44.9290167,17.4462838 43.3517944,17.1043919",
    id: "Fill-13",
    fill: "#00B69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2562111,13.7893243 C39.2562111,14.6724324 40.4481,15.0643243 41.9799889,15.3832432 L41.9799889,12.1014865 C40.3829333,12.1778378 39.2562111,12.8582432 39.2562111,13.7893243",
    id: "Fill-15",
    fill: "#00B69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7010167,0.62027027 L14.2969056,0.62027027 L2.55651667,0.62027027 L2.55651667,9.01891892 L2.55651667,24.8182432 L5.10462778,26.6506757 L5.10462778,9.20337838 C7.35618333,9.08986486 9.64362778,8.30472973 11.4767944,6.99932432 C13.2929611,5.70135135 14.3856833,4.02905405 14.5490722,2.43513514 L70.4535722,2.43513514 C70.6179056,4.02905405 71.7087389,5.70135135 73.5230167,6.99932432 C75.3561833,8.30472973 77.6436278,9.08986486 79.8951833,9.20337838 L79.8951833,23.6344595 C77.6436278,23.7412162 75.3561833,24.5263514 73.5230167,25.8324324 C71.7087389,27.1310811 70.6179056,28.802027 70.4535722,30.3932432 L10.3377944,30.3932432 L12.8896833,32.2135135 L70.7010167,32.2135135 L82.4414056,32.2135135 L82.4414056,23.8121622 L82.4414056,9.01891892 L82.4414056,0.62027027 L70.7010167,0.62027027 Z",
    id: "Fill-17",
    fill: "#00B69F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#00D7C1",
    points: "15.4343944 22.9980405 7.72111667 28.5196622 14.12445 33.1000676 15.4372278 34.0385811 30.8656722 34.0385811"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(0.000000, 22.972973)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#00C6AD",
    mask: "url(#mask-2)",
    points: "15.4376056 0.0250675676 15.4376056 11.0656081 -0.000283333333 0.0250675676"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentaRenta);
export default __webpack_public_path__ + "static/media/venta-renta.a91fc3dff8eb51be67fda32222c9fbe5.svg";
export { ForwardRef as ReactComponent };